/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import React from 'react';
import { GlobalStyles } from './src/styles/GlobalStyles';
import { FontStyles } from './src/styles/fontStyles';
import LanguageContextProvider from 'gatsby-theme-objects/src/utils/LanguageContext';
import { captureAttribution } from 'gatsby-theme-objects/src/utils/attribution';
import { Global } from '@emotion/react';

// Capture visitor origin (utm_*, gclid, fbclid, referrer) on first load and on
// every route change. First-touch is kept once; the quote-submit body reads it
// back to fill the Odoo crm.lead. No cookie, no third party.
export const onClientEntry = () => captureAttribution();
export const onRouteUpdate = () => captureAttribution();

// Disable Gatsby's built-in service worker — it caches stale JS bundles
// and causes users to see old code after deploys (e.g. "Dev mode" bug).
export const registerServiceWorker = () => false;

// Unregister any existing service worker from previous deploys
if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => r.unregister());
  });
}

export const shouldUpdateScroll = () => {
  //scroll to top on router change
  window.scrollTo(0, 0);
  return false;
};

export const wrapRootElement = ({ element }) => (
  <>
    <LanguageContextProvider>{element}</LanguageContextProvider>
  </>
);

export const wrapPageElement = ({ element, ...props }) => {
  return (
    <>
      <Global styles={GlobalStyles} />
      <Global styles={FontStyles} />
      {element}
    </>
  );
};
